<template>
  <div id="app">
    <router-view/>
    <!--b-toast id="my-toast" @shown="showLoginForm" no-auto-hide solid>
      <template slot="toast-title">
        <div class="d-flex flex-grow-1 align-items-baseline">
          <strong class="mr-auto text-danger">Авторизуйтесь!</strong>
        </div>
      </template>
      <template slot="default">
        <b-form class="login" @submit.prevent="loginMethod">
          <b-row class="my-1 b-center">
            <b-col md="12" class="mb-1">
              <b-form-input id="input-none" :state="true" type="text" placeholder="Логин"
                            v-model="form.username" required></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1 b-center">
            <b-col md="12">
              <b-form-input id="input-valid" :state="true" type="password" placeholder="Пароль"
                            v-model="form.password" required></b-form-input>
            </b-col>
          </b-row>
          <b-row class="b-center" v-show="status==='error'">
            <b-col md="6">
              <b-alert show variant="danger">Пожалуйста, проверьте правильность написания логина и пароля.
              </b-alert>
            </b-col>
          </b-row>
          <b-row class="b-center">
            <b-col md="6">
              <b-button block @click="loginMethod" id="log_in" class="login" variant="success">Войти</b-button>
            </b-col>
            <b-col md="6">
              <b-button block @click="logoutMethod" id="log_out" class="logout">Выйти</b-button>
            </b-col>
          </b-row>
        </b-form>
      </template>
    </b-toast-->
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  components: {},
  beforeMount () {
    this.updateScreens()
    window.addEventListener('resize', () => {
      this.updateScreens()
    })
  },
  created () {
    axios.interceptors.response.use(function (response) {
      return response
    }, (error) => {
      if (axios.isCancel(error)) {
        return Promise.reject(error)
      } else {
        this.showToast(error.response, error.config)
        return Promise.reject(error)
      }
    })
    window.addEventListener('storage', () => {
      axios.defaults.headers.common.Authorization = window.localStorage.getItem('token_castle_authorization')
    })
  },
  computed: {
    ...mapState(
      {
        status: state => state.authorization.status,
        token: state => state.authorization.token
      }
    )
  },
  methods: {
    ...mapActions('authorization',
      [
        'login',
        'showUserInfo'
      ]
    ),
    ...mapMutations(
      {
        updateScreenWidth: 'updateScreenWidth',
        updateMobile: 'updateMobile',
        updateTablet: 'updateTablet',
        updateDesktop: 'updateDesktop',
        updateLargeDesktop: 'updateLargeDesktop'
      }
    ),
    updateScreens () {
      this.updateScreenWidth(document.documentElement.clientWidth)
      this.updateMobile(Boolean(document.documentElement.clientWidth < 768))
      this.updateTablet(Boolean(document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth < 1024))
      this.updateDesktop(Boolean(document.documentElement.clientWidth >= 1024 && document.documentElement.clientWidth < 1440))
      this.updateLargeDesktop(Boolean(document.documentElement.clientWidth >= 1440))
    },
    showLoginForm () {
      if (document.getElementsByClassName('modal-content') && document.getElementsByClassName('modal-content').length > 0) {
        document.getElementsByClassName('modal-content')[0].removeAttribute('tabindex')
      }
    },
    showToast (error, originalRequest) {
      let toastTitle = null
      if (error.status === 400) {
        if (error.data.detail) {
          toastTitle = error.data.detail + ' (ErrorCode: 400)'
        } else {
          toastTitle = 'Отправлены некорректные данные'
        }
      } else if (error.status === 401) {
        localStorage.removeItem('token_castle_authorization')
        localStorage.removeItem('castleUserInfo')
        delete axios.defaults.headers.common.Authorization
        /* if (!(originalRequest.url === '/api/private/v3.0/logout/')) {
          this.$bvToast.show('my-toast')
        } */
        this.$router.push({ name: 'log-in' })
      } else if (error.status === 403) {
        toastTitle = 'Отказано в доступе'
      } else if (error.status === 404) {
        toastTitle = 'Запрашиваемый ресурс не найден'
      } else if (error.status === 409) {
        if (error.data.detail) {
          toastTitle = error.data.detail + ' (ErrorCode: 409)'
        } else {
          toastTitle = 'Сервис временно недоступен (ErrorCode: 409)'
        }
      } else if (error.status === 500) {
        toastTitle = 'Сервис временно недоступен(500)'
      } else if (error.status === 502) {
        toastTitle = 'Сервис временно недоступен(502)'
      } else if (error.status === 503) {
        toastTitle = 'Сервис временно недоступен(503)'
      } else if (error.status === 504) {
        toastTitle = 'Сервис временно недоступен(504)'
      }
      this.$bvToast.toast(toastTitle, {
        title: 'Что-то пошло не так',
        variant: 'danger',
        name: 'b-toaster-top-center'
      })
    }
    /* loginMethod () {
      this.login(this.form).then(
        () => {
          this.showUserInfo().then(
            () => {
              // this.$bvToast.hide('my-toast')
              if (this.$route.name === 'log-in') {
                this.$router.push('/')
              }
            },
            error => {
              console.log(error)
            }
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    logoutMethod () {
      // this.$bvToast.hide('my-toast')
      this.$router.push({ name: 'log-in' })
    } */
  }
}
</script>

<style lang="scss">
  @import 'assets/custom-bootstrap.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import '../node_modules/bootstrap-vue/src/index.scss';
  @import 'assets/fontawesome/css/all.css';

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #app {
      height: 100vh !important;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
</style>
